import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Field } from '../components/ui.jsx';
import { useToast } from '../state/ToastContext.jsx';
import { useTitle } from '../lib/hooks.js';
import { ApiError, api } from '../api/client.js';

const ForgotPassword = () => {
  useTitle('Reset your password');
  const toast = useToast();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');

    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setSubmitted(true);
      toast.success('Check your email for a password reset link.');
    } catch (err) {
      if (err instanceof ApiError && err.details) {
        setError(err.details.email || err.message);
      } else {
        setError(err.message || 'Something went wrong.');
      }
    } finally {
      setBusy(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page container">
        <div className="auth-card">
          <h1>Check your email</h1>
          <p className="muted">
            We've sent a password reset link to <strong>{email}</strong>. The link expires in 24 hours.
          </p>

          <div className="notice notice-good" style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
            Check your spam folder if you don't see the email.
          </div>

          <p className="auth-alt">
            Remember your password? <Link to="/login">Sign in instead</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>Reset your password</h1>
        <p className="muted">
          Enter your email and we'll send you a link to reset your password.
        </p>

        {error ? <div className="notice notice-bad">{error}</div> : null}

        <form className="stack" onSubmit={submit}>
          <Field label="Email" required>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="landlord@example.cm"
              disabled={busy}
            />
          </Field>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={busy}>
            {busy ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        <p className="auth-alt">
          Remember your password? <Link to="/login">Sign in instead</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
